import { AssetWithHighlight, SharedEventView } from './SharedEventView'

export function MovementEventView({ assets }: Props) {
  return <SharedEventView assets={assets} isEventMove={true} />
}

type Props = {
  assets: AssetWithHighlight[]
}
